import { useRef } from 'react';
import { useFetch } from '@/app/hooks';
import { reportEvent } from '@/app/utils';
import { nexusValidateBonusCode } from '../apis';

export const useValidateBonusCode = ({ onValidate }: { onValidate: (error: string) => void }) => {
  const codeRef = useRef('');

  const { run: runValidate, loading: validateBonusCodeLoading } = useFetch(
    (code: string) => nexusValidateBonusCode({ path: { code } }),
    {
      manual: true,
      onSuccess: ({ data, error }) => {
        if (error) {
          reportEvent('cpp_code_verify', { result: 'fail', cpp_code_id: '' });
          onValidate(error?.reason || 'error');
          return;
        }
        if (!data.valid) {
          reportEvent('cpp_code_verify', { result: 'invalid', cpp_code_id: '' });
          onValidate('error');
          return;
        }
        reportEvent('cpp_code_verify', { result: 'valid', cpp_code_id: codeRef.current });
        onValidate('');
      },
    },
  );

  const validateBonusCode = (code: string) => {
    codeRef.current = code;
    runValidate(code);
  };

  return {
    validateBonusCode,
    validateBonusCodeLoading,
  };
};
